import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
import { ImgixImage } from "~/components/ImgixImage";
import { getCloudFrontUrlFromImgixUrl } from "~/constants/cloudfront";
import { BOARD_CARD_THUMBNAIL } from "~/constants/testIDs";
/**
 * This is used to display board's thumbnail (only image)
 */ const BoardThumbnail = /*#__PURE__*/ memo((param)=>{
    let { board: { thumbnails, title }, children, sizes, width, height, borderRadius = 4, onClick, imgixParams, className, objectFit = "contain" } = param;
    const thumbnail = thumbnails && thumbnails.length ? thumbnails[0] : null;
    const isBase64Image = thumbnail && thumbnail.startsWith("data:image");
    const fallbackUrl = thumbnail && getCloudFrontUrlFromImgixUrl(thumbnail);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "".concat(BOARD_CARD_THUMBNAIL, "-").concat(title),
        className: tailwindMerge("relative overflow-hidden [&>img]:relative [&>img]:h-full [&>img]:w-full", onClick ? "cursor-pointer" : "cursor-default", className),
        style: {
            cursor: onClick ? "pointer" : "default",
            width,
            height,
            minWidth: width,
            borderRadius
        },
        onClick: onClick,
        children: [
            isBase64Image ? // eslint-disable-next-line @next/next/no-img-element
            /*#__PURE__*/ _jsx("img", {
                src: thumbnail,
                alt: title,
                style: {
                    objectFit
                }
            }) : fallbackUrl && thumbnail ? /*#__PURE__*/ _jsx(ImgixImage, {
                fallbackUrl: fallbackUrl,
                sizes: sizes,
                alt: title,
                src: thumbnail,
                imgixParams: {
                    w: 400,
                    h: 400,
                    auto: "compress",
                    fit: "contain",
                    cs: "origin",
                    ...imgixParams
                },
                width: 400,
                height: 400,
                style: {
                    objectFit
                }
            }) : /*#__PURE__*/ _jsx("div", {
                className: "size-full bg-grey-3"
            }),
            children
        ]
    });
});
BoardThumbnail.displayName = "BoardThumbnail";
export default BoardThumbnail;
